// @flow
import * as React from 'react';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

export default () => (
  <Breadcrumb>
    <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
    <Breadcrumb.Item>Suppliers</Breadcrumb.Item>
  </Breadcrumb>
);
